import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { SolicitacaoService } from 'src/app/core/apis/solicitacao/solicitacao.service';
import { Ordem } from 'src/app/core/model/ordem';
import { AuthService } from 'src/app/core/auth/service/auth.service';
import { Globals } from 'src/app/shared/helpers/globals';
import { CpfCnpjService } from 'src/app/core/service/cpf-cnpj.service';
import { DialogService } from 'src/app/core/service/dialog.service';
import { NroProcessoInputComponent } from 'src/app/shared/components/nro-processo-input/nro-processo-input.component';
import { AtualizarAcaoFormComponent } from './formulario/atualizar-acao-form/atualizar-acao-form.component';
import { IncluirAcaoFormComponent } from './formulario/incluir-acao-form/incluir-acao-form.component';
import { TipoOrdem } from 'src/app/core/model/enum/tipo-ordem.enum';


@Component({
    selector: 'app-inclusao-acao',
    templateUrl: './inclusao-acao.component.html',
    providers: [provideNgxMask()],
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgIf,
        MatButtonModule,
        IncluirAcaoFormComponent,
        AtualizarAcaoFormComponent,
        NroProcessoInputComponent
    ]
})
export class InclusaoAcaoComponent {

  @Input() tokenIam: string;

  form: UntypedFormGroup;
  ordem: Ordem;
  consultaAcaoRealizada: boolean = false;
  existeAcao: boolean = false;

  constructor(
    private solicitacaoService: SolicitacaoService,
    public cpfCnpjService: CpfCnpjService,
    public authService: AuthService,
    private dialogService: DialogService,
    private globals: Globals,
    private router: Router,
    fb: UntypedFormBuilder) {
    this.form = fb.group({
      nroProcesso: [""]
    });
  }

  public buscarOrdem(): void {
    this.globals.addToLoading("cadastrar-ordem");
    this.solicitacaoService.findByNroProcesso(this.nroProcesso.value, [TipoOrdem.ACAO], this.tokenIam).subscribe({
      next: (data) => {
        this.ordem = data.body;
        if (this.ordem.tipoOrdem !== TipoOrdem.ACAO) {
          this.nroProcesso.disable();
          this.consultaAcaoRealizada = true;
          this.globals.subtractFromLoading();
        } else if (this.ordem.status === "AGUARDANDO_ENVIO" || this.ordem.status === "EM_ATENDIMENTO") {
          this.globals.subtractFromLoading();
          this.dialogService.showOrdemEmAtendimentoDialog(this.ordem);
        } else {
          this.nroProcesso.disable();
          this.existeAcao = true;
          this.consultaAcaoRealizada = true;
          this.globals.subtractFromLoading();
          this.openAtualizarOrdemDialog();
        }
      },
      error: (error) => {
        this.nroProcesso.disable();
        this.consultaAcaoRealizada = true;
        this.globals.subtractFromLoading();

        // Ignora erro 404 (ordem não encontrada)
        if (error?.status === 404) {
          return;
        }

        this.globals.showSnackBar("Falha ao consultar ordens, por favor tente novamente mais tarde.");
      }
    });
  }

  public openAtualizarOrdemDialog(): void {
    this.dialogService.showConfirmation(
        ['Ação encontrada na base de dados do Serasa.', 'Deseja atualizar esta ação?'],
        'Atualizar',
        'Voltar',
        '400px'
      )
      .subscribe(confirm => {
        if (!confirm) {
          this.router.navigate(['ordem']);
        }
      });
  }

  get nroProcesso() {
    return this.form.get('nroProcesso');
  }
}
